import React from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../../modules/auth';
import UserMenu from '../../../components/common/header/UserMenu'

const UserMenuContainer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { user } = useSelector(({ auth }) => ({
        user: auth.user,
    }));

    const onLogout = () => {
        // [추가] 유저 메뉴를 통해 로그아웃할 때도 자동 로그인 브레이크 증표를 남깁니다.
        try {
            sessionStorage.setItem('justLoggedOut', 'true');
        } catch (e) {
            console.error('sessionStorage 저장 실패:', e);
        }

        navigate('/login');
        dispatch(logout());
    };

    return (
        <UserMenu user={user} onLogout={onLogout} />
    )
}

export default UserMenuContainer;
